import React, { useEffect, useState } from 'react';
import Phone from '../assets/iphone.svg';
import Paper from '../assets/background-paper.png';
import Paper2 from '../assets/background-paper2.png';
import SomeoneDrewTheBottom from '../assets/someone-drew-the-bottom.svg';
import './rotation.css';
import './animate.css';

import Reveal1 from '../assets/reveal-transition-1.png';
import Reveal2 from '../assets/reveal-transition-2.png';
import Reveal3 from '../assets/reveal-transition-3.png';
import Reveal4 from '../assets/reveal-transition-4.png';
import Reveal5 from '../assets/reveal-transition-5.png';
import Reveal6 from '../assets/reveal-transition-6.png';

import RevealTop from '../assets/reveal-top.gif';
import RevealMiddle from '../assets/reveal-middle.gif';
import RevealBottom from '../assets/reveal-bottom.gif';

import ImageSequenceComponent from './imagesequence';

function Rotation() {
    const [rotation, setRotation] = useState(0);
    const [position, setPosition] = useState("static");

    const [opacitySomeoneDrewTheBottom, setOpacitySomeoneDrewTheBottom] = useState("");

    const [opacityTop, setOpacityTop] = useState("");
    const [opacityMiddle, setOpacityMiddle] = useState("");
    const [opacityBottom, setOpacityBottom] = useState("");

    const [opacityTopImage, setOpacityTopImage] = useState("");
    const [opacityMiddleImage, setOpacityMiddleImage] = useState("");
    const [opacityBottomImage, setOpacityBottomImage] = useState("");

    const [startSequence, setStartSequence] = useState(false);
    const [reverseSequence, setReverseSequence] = useState(false);

    var images = [
        Reveal1,
        Reveal2,
        Reveal3,
        Reveal4,
        Reveal5,
        Reveal6
      ];

    useEffect(() => {
        let prevScrollY = 0; // Variable to store previous scroll position

        const handleScroll = () => {

            // SECTION --- Scroll Up or Down
            const scrollY = window.scrollY;
            const scrollDirection = scrollY > prevScrollY ? 'down' : 'up'; // Detect scroll direction

            // Add a condition to check screen width
            const screenWidth = window.innerWidth;

            if (screenWidth > 560) {
                setRotation(-90);
                // Your existing scroll event logic for rotation effect
                // ... (existing logic)

                const scrollY = window.scrollY;
                // const container = document.querySelector('.container');

                // Get the position of the trigger divs
                const startDivPosition = document.getElementById('start-div').getBoundingClientRect().top + 48;
                const positionTop = document.getElementById('top').getBoundingClientRect().top;
                const positionMiddle = document.getElementById('middle').getBoundingClientRect().top;
                const positionBottom = document.getElementById('bottom').getBoundingClientRect().top;

                // Check if the current scroll position is between the two divs
                if (scrollY >= startDivPosition) {
                    let newRotation = -90 + ((scrollY - startDivPosition) * 0.25); // Adjust the factor for desired rotation speed

                    // Limit rotation to a maximum of 90 degrees
                    if (newRotation > 0) {
                        newRotation = 0;
                        setPosition("sticky");
                        setOpacitySomeoneDrewTheBottom("fadeOut")

                        // HERE --> Update with the reveal Image

                        // Update rotation and other effects based on scroll direction if needed
                        if (scrollDirection === 'down') {
                            // Scrolling down logic
                            // Example: setOpacity or other effects when scrolling down
                            setReverseSequence(false);
                            setStartSequence(true);
                            console.log("ELSE 1 - down")
                        } else {
                            // Scrolling up logic
                            // Example: setOpacity or other effects when scrolling up
                            console.log("ELSE 1 - uppies")
                        }

                    } else {
                        setPosition("static");
                        setOpacitySomeoneDrewTheBottom("")

                        // Update rotation and other effects based on scroll direction if needed
                        if (scrollDirection === 'down') {
                            // Scrolling down logic
                            // Example: setOpacity or other effects when scrolling down
                            console.log("ELSE 2 - down")
                        } else {
                            // Scrolling up logic
                            // Example: setOpacity or other effects when scrolling up
                            console.log("ELSE 2 - uppies")
                            setReverseSequence(true);
                            setStartSequence(true);
                            // Switch to the reverse sequence
                        }
                    }

                    setRotation(newRotation);

                } else if (scrollY < startDivPosition) {
                    setRotation(-90); // Reset rotation if above the start div
                    setPosition("static"); // Reset isSticky if above the start div

                    // Update rotation and other effects based on scroll direction if needed
                    if (scrollDirection === 'down') {
                        // Scrolling down logic
                        // Example: setOpacity or other effects when scrolling down
                        console.log("ELSE 3 - down")
                    } else {
                        // Scrolling up logic
                        // Example: setOpacity or other effects when scrolling up
                        // setReverseSequence(true);
                        console.log("ELSE 3 - uppies")
                    }
                }

                // Top
                if (scrollY >= positionTop + 800) {
                    setOpacityTop("popIn");
                    setOpacityTopImage("appear");
                } else if (scrollY < positionTop + 800) {
                    setOpacityTop("");
                    setOpacityTopImage("disappear");
                }

                // Middle
                if (scrollY >= positionMiddle + 1600) {
                    setOpacityMiddle("popIn");
                    setOpacityMiddleImage("appear");
                } else if (scrollY < positionMiddle + 1600) {
                    setOpacityMiddle("");
                    setOpacityMiddleImage("disappear");
                }

                // Bottom
                if (scrollY >= positionBottom + 2400) {
                    setOpacityBottom("popIn");
                    setOpacityBottomImage("appear");
                } else if (scrollY < positionBottom + 2400) {
                    setOpacityBottom("");
                    setOpacityBottomImage("disappear");
                }

            } else {
                // Reset rotation and states if screen size is above 480px

                setRotation(0);
                setPosition("static");
                setStartSequence(false);
                setReverseSequence(false);
                setOpacityTop("");
                setOpacityMiddle("");
                setOpacityBottom("");
            }

            prevScrollY = scrollY; // Store current scroll position for the next comparison
        }

    // Initial check for screen width and setRotation before scrolling starts
    handleScroll();

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className="rotation">
        <div id="start-div" className="start-div"></div>
        <div className="container">
            <div className="spacer" style={{ backgroundImage: 'url(' + Paper + ')' }}></div>
            <div className="spacer2" style={{ backgroundImage: 'url(' + Paper2 + ')' }}></div>
            <div className="rotating-image-container popIn" style={{ position: `${position}` }}>
                <img src={ SomeoneDrewTheBottom } alt="Someone drew the bottom" className={"someone-drew-the-bottom " + opacitySomeoneDrewTheBottom} />
                <div className="rotating-image" style={{ transform: `rotate(${rotation}deg)`, position: `${position}` }}>
                {/* // <img
                //   src={ test }
                //   alt="Rotating Image"
                //   className="phone"
                // /> */}
                    <ImageSequenceComponent shouldChange={startSequence} imageSet={images} alternateImageSet={images.slice().reverse()} useAlternateSet={reverseSequence}/>
                    <img src={ Phone } alt="Rotating" className="frame" />
                    <img src={ RevealTop } alt ="Top" className={"animated-canvas " + opacityTopImage} />
                    <img src={ RevealMiddle } alt ="Middle" className={"animated-canvas " + opacityMiddleImage} />
                    <img src={ RevealBottom } alt ="Bottom" className={"animated-canvas " + opacityBottomImage} />
                </div>
                <div id="top" className={"topmiddlebottom " + opacityTop} style={{ position: "fixed" }} >
                    <div>
                        <h2>The Top</h2>
                        <p>Get the creative juices flowing and draw a head full of personality! Who knows where this is going.</p>
                    </div>
                </div>
                <div id="middle" className={"topmiddlebottom " + opacityMiddle} style={{ position: "fixed" }} >
                    <div></div>
                    <div>
                        <h2>The Middle</h2>
                        <p>Keep the creativity rolling and draw the body! You won’t know what’s already been drawn.</p>
                    </div>
                </div>
                <div id="bottom" className={"topmiddlebottom " + opacityBottom} style={{ position: "fixed" }} >
                    <div>
                        <h2>The Bottom</h2>
                        <p>Put your best foot forward and draw some legs! After your done, it's time for the reveal!</p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
  );
}

export default Rotation;
